export const idleTimer = {
    tokenRefreshInterval: 10,    // in minutes
    timeoutInterval: 20,        // in minutes
    warningTime: 5,             // in minutes
}
